@if (!registerProductTile && !redeemS17Tile) {
  <div class="card product-card" role="group" aria-label="product">
    <div class="downloads_header" (click)="tileClick()">
      <div class="d-flex justify-content-center align-items-center m-b-10">
        @if (product && userService.userMetadataLoaded && (!userService.userMetadata.products_seen || !userService.userMetadata.products_seen[product.id])) {
          <span class="unread-badge">
            <span class="sr-only">{{ "accessibility.status_unread" | translate }}</span>
          </span>
        }
      </div>
    </div>
    <div class="image-container d-flex h-full m-b-20 align-items-center justify-content-center" (click)="tileClick()">
      @if (image) {
        <img [src]="image" class="product-image" alt="" />
      }
      @if (!image && product?.isMissingFenderSerial && !product?.bodyImageUrl) {
        <myp-svg id="fender-headstock" width="200" height="200" class="svg-muted"></myp-svg>
      }
    </div>
    @if (product?.redeemable) {
      <div class="tile-bottom w-full justify-content-center m-y-10">
        <button class="brand-btn-reverse sm m-r-10" (click)="redeemProduct()">{{ "products.claim_product" | translate }}</button>
        @if (!redeeming) {
          <fa-icon icon="info-circle" (click)="redeemInfo()"></fa-icon>
        }
        @if (redeeming) {
          <fa-icon icon="spinner" animation="spin"></fa-icon>
        }
      </div>
    }
    <div class="title-container" (click)="tileClick()">
      <span class="title-text">{{ title }}</span>
      @if (showStrippedDescription && product && (product.shortDescription || product.description)) {
        <div class="tile-stripped-description">{{ product.shortDescription || product.description | stripHtml }}</div>
      }
      @if (product && (product.shortDescription || product.description) && product.partnerName == "third_party") {
        <div class="description-container">
          <div class="description">{{ product.shortDescription || product.description | stripHtml }}</div>
          <a class="small-btn" (click)="showDescriptionModal($event)" href="#">{{ "products.view_more_details" | translate }}</a>
        </div>
      }
    </div>
    <div class="d-flex m-x-10 m-b-5 justify-content-between">
      <div>
        @if (showDate && product && product.categoryId == "hardware" && (product.aquired || product.releaseDate)) {
          <span class="t-12" (click)="tileClick()">
            {{ product.aquired || product.releaseDate | date }}
          </span>
        }
        @if (showDate && product && product.categoryId != "hardware" && (product.releaseDate || product.aquired)) {
          <span class="t-12" (click)="tileClick()">
            {{ (product.releaseDate ? "general.updated" : "general.added") | translate }}
            {{ product.releaseDate || product.aquired | date }}
          </span>
        }
      </div>
      @if ((product && !product?.redeemable) || productLink) {
        <div class="d-flex align-items-center">
          @if (product && product.includedInSubscription) {
            <button type="button" role="link" class="product-tile-icon-btn" [ngbTooltip]="'newdash.included_studio_one_pro' | translate" tooltipClass="nowrap">
              <img [src]="'./assets/icons/plus-icon-blue.png'" class="action prod-sphere-icon" alt="" />
              <span class="sr-only">{{ "newdash.included_studio_one_pro" | translate }}</span>
            </button>
          }
          @if (product && product.featuredSample) {
            <button
              type="button"
              role="link"
              class="product-tile-icon-btn"
              (keyup.enter)="playSample(product.featuredSample, $event)"
              (click)="playSample(product.featuredSample, $event)"
              [ngbTooltip]="'products.play_sample' | translate"
              placement="top"
              tooltipClass="nowrap"
            >
              <fa-icon icon="play-circle" class="tile-action-btn" aria-hidden="true"></fa-icon>
              <span class="sr-only">{{ "accessibility.play_sample_button" | translate }}</span>
            </button>
          }
          @if (product && product.categoryId == "software") {
            <button
              type="button"
              class="product-tile-icon-btn"
              (keyup.enter)="downloadInstaller(product)"
              (click)="downloadInstaller(product)"
              [ngbTooltip]="'products.download_installer' | translate"
              placement="top"
              tooltipClass="nowrap"
            >
              <fa-icon icon="download" class="tile-action-btn"></fa-icon>
              <span class="sr-only">{{ "products.download_installer" | translate }}</span>
            </button>
          }
          @if (product && product.id) {
            <button type="button" role="link" class="product-tile-icon-btn" (click)="tileClick()" [ngbTooltip]="'general.view_product' | translate" placement="top" tabindex="0" tooltipClass="nowrap">
              <fa-icon icon="chevron-right" class="t-16"></fa-icon>
              <span class="sr-only">{{ "general.view_product" | translate }}</span>
            </button>
          }
          @if (productLink) {
            <a
              class="product-tile-icon-btn"
              [href]="productLink"
              target="_blank"
              rel="noopener noreferrer"
              [ngbTooltip]="'products.view_more_details' | translate"
              placement="top"
              tooltipClass="nowrap"
            >
              <fa-icon icon="chevron-right" class="t-16"></fa-icon>
              <span class="sr-only">{{ "products.view_more_details" | translate }}</span>
            </a>
          }
        </div>
      }
    </div>
    @if (productService.elligleToRedeemStudioOneSeven && product.id == env.product_ids.s16pro) {
      <div class="m-t-10">
        <button class="btn btn-primary" (click)="showRedeemS17()">{{ "general.redeem_pro_7" | translate }}</button>
      </div>
    }
    @if (buyNowUrl) {
      <a class="tile-buy-now" [href]="buyNowUrl" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
        Buy Now
        <fa-icon icon="chevron-right"></fa-icon>
      </a>
    }
  </div>
}
<!-- START | card: register product -->
@if (registerProductTile) {
  <div class="card register-product-card" role="group" aria-label="register product" (click)="registerProductClicked.next(true)">
    <fa-icon icon="plus-circle" class="register-product-icon"></fa-icon>
    <div class="register-product-content text-center">
      {{ "newdash.prod_page_slug" | translate }}
      <br />
      <button type="button" class="btn btn-secondary register-product-btn" role="link" tabindex="0" #register>{{ "newdash.register_product" | translate }}</button>
    </div>
  </div>
}
<!-- END | card: register product -->
<!-- START | card: redeem studio one 7 -->
@if (redeemS17Tile) {
  <div class="card register-product-card" role="group" aria-label="register product">
    <img class="align-self-start product-image" src="./assets/images/s17-images/s17-box.png" style="max-width: 300px" alt="" />
    <div class="card-body px-0 pb-0">
      <p class="card-text">{{ "newdash.studio_one_seven_eligible" | translate }}</p>
      <button type="button" class="brand-btn-reverse sm m-b-20" role="link" tabindex="0" (click)="redeems17Clicked.next(true)" #register>{{ "newdash.redeem_studio_one_seven" | translate }}</button>
    </div>
  </div>
}
<!-- END | card: redeem studio one 7 -->
